<template>
  <v-autocomplete
      v-model="value"
      :items="values"
      :label="label"
      item-text="name"
      item-value="id"
      return-object
      hide-details
  />
</template>

<script>
import VueTypes from "vue-types";
import {CurrencyDeprecateMode} from "@/modules/redactor/models/currency/CurrencyDeprecateMode";

export default {
  name: "r-currency-deprecate-mode",
  props: {
    model: VueTypes.instanceOf(CurrencyDeprecateMode),
    label: VueTypes.string.def("Mode:")
  },
  computed: {
    value: {
      get: function () {
        return this.model;
      },
      set: function (value) {
        this.$emit("update:model", value);
      }
    },
    values() {
      return CurrencyDeprecateMode.getValues();
    }
  }
}

</script>
